import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class AuthService {  

  constructor() {} 

  get isLoggedIn(): boolean {
    let authToken = localStorage.getItem('access_token');
    return authToken !== null ? true : false;
  }
}
